import './fast-import-modal.scss'

export default class FastImportModalController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('@knitiv/api-client-javascript').KNode} fastImport
	 * @param {import('~/scripts/services/model/form').default} form
	 */
	constructor(
		$uibModalInstance,
		fastImport,
		form,
	) {
		this.$uibModalInstance = $uibModalInstance;

		const variables = {
			FASTIMPORT_rattachement: form.kid,
		};

		this.src = `importfile/assistant?import=${fastImport}&variables=${JSON.stringify(variables)}&hideNavbar=1`;
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		return this.$uibModalInstance.close();
	}

	/**
	 * Handle frame messages
	 * @param {{ event: string; from: string }} message - Message
	 */
	onMessage(message) {
		if (message.event === 'close-modal') {
			this.$uibModalInstance.close(true);
		}
	}
}
